import React from 'react';
import { useQuery, useMutation } from '@apollo/client/react';
import { useParams, useNavigate } from 'react-router-dom';
import { gql } from '@apollo/client';
import Breadcrumb from '../components/Breadcrumb';
import ResourceForm from '../components/ResourceForm';
import { CREATE_TEAM, UPDATE_TEAM } from '../graphql/mutations';
import { TEAMS_QUERY } from '../graphql/queries';

const TEAM_QUERY = gql`
  query Team($id: ID!) {
    team(id: $id) {
      id
      name
      description
    }
  }
`;

const FORM_FIELDS = [
  { key: 'name', label: 'Name', type: 'text', required: true },
  { key: 'description', label: 'Description', type: 'textarea', rows: 3 }
];

export default function TeamFormPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data } = useQuery(TEAM_QUERY, { variables: { id }, skip: !id });

  const [updateTeam, { loading: updateLoading }] = useMutation(UPDATE_TEAM, {
    refetchQueries: [{ query: TEAMS_QUERY }],
    awaitRefetchQueries: true
  });

  const [createTeam, { loading: createLoading }] = useMutation(CREATE_TEAM, {
    refetchQueries: [{ query: TEAMS_QUERY }],
    awaitRefetchQueries: true
  });

  const loading = updateLoading || createLoading;
  const team = data?.team;

  const handleSubmit = async (formState) => {
    try {
      const input = { name: formState.name, description: formState.description || null };
      if (id) {
        await updateTeam({ variables: { input } });
      } else {
        await createTeam({ variables: { input } });
      }
      navigate('/teams');
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="page-content">
      <Breadcrumb
        items={[{ label: 'Teams', link: '/teams' }, { label: id ? 'Edit Team' : 'New Team' }]}
      />
      <ResourceForm
        resource={team ? { ...team, type: 'Team' } : null}
        fields={FORM_FIELDS}
        onSubmit={handleSubmit}
        onCancel={() => navigate(-1)}
        loading={loading}
        submitLabel={id ? 'Update Team' : 'Create Team'}
      />
    </div>
  );
}
